import { ActionType, createAction } from "typesafe-actions";

import type { WordCloudConfig } from "@app/component/executiveSummary/types";
import Scope from "@app/types/dashboard/Scope";

export const fetchWordCloudSettings = createAction("@dashboard/fetchWordCloudSettings")<{
  callback: (config: WordCloudConfig) => void;
  failureCallback?: () => void;
  scope: Scope;
}>();

export const saveWordCloudSettings = createAction("@dashboard/saveWordCloudSettings")<{
  callback: (config: WordCloudConfig) => void;
  config: WordCloudConfig;
  failureCallback?: () => void;
  scope: Scope;
}>();

export type WordCloudSettingsActions = ActionType<
  typeof fetchWordCloudSettings | typeof saveWordCloudSettings
>;
